import { TKIconPencil } from "assets/images/svgs";
import React, { useState } from "react";
import InputField from "shared/InputField";

const AccountDetails = ({ ngoProfile }) => {
  const [editing1, setEditing1] = useState(false);

  return (
    <div className="bg-white rounded-md p-8 w-full h-full">
      <div>
        <p className="my-4 font-semibold">NGO Account Details</p>
        <form>
          <div className="flex justify-between gap-3 flex-wrap">
            <div className="w-[422px] flex flex-col gap-y-2">
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Bank Name
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="Praise Bank"
                  name="ngoBankName"
                  id="ngoBankName"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Account Number
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="1234567890"
                  name="accountNumber"
                  id="accountNumber"
                />
              </div>
            </div>
            <div className="w-[422px] flex flex-col gap-y-4">
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Beneficiary of Account
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="Praise Charity NGO"
                  name="beneficiary"
                  id="beneficiary"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Name of Authorized Signatories to Account
                </label>
                <textarea
                  disabled={!editing1}
                  className="px-2 py-1 bg-[#F6F6F6F6]  rounded-md placeholder:text-[14px] placeholder:text-[#212121]"
                  rows="5"
                  name="authorizedSignatories"
                  defaultValue="Akobundu Praise"
                  placeholder="Please provide the following details"
                />
              </div>
            </div>
          </div>
          <div
            className={`my-6 flex ${
              editing1 ? "justify-end" : "justify-between"
            }`}
          >
            {!editing1 && (
              <div
                onClick={() => setEditing1(!editing1)}
                className="cursor-pointer w-[80px] flex justify-center items-center border rounded-2xl gap-x-1 p-1 border-[#213874] hover:font-medium"
              >
                <TKIconPencil />
                <p className="text-[#213874]">Edit</p>
              </div>
            )}
            {editing1 && (
              <div className={`flex gap-x-2 ${editing1 && "justify-end"}`}>
                <button
                  onClick={() => setEditing1(!editing1)}
                  type="button"
                  className="w-[100px] bg-[#E0E0E0] p-2 rounded-sm"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="w-[100px] text-white bg-[#61CE70] p-2 rounded-sm"
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      <div></div>
    </div>
  );
};

export default AccountDetails;
